<div class="app-layout">
  <header class="header">
    <app-header></app-header>
  </header>

  <app-update-banner></app-update-banner>
  <app-mfa-grace-banner></app-mfa-grace-banner>

  <main class="private-content">
    <router-outlet></router-outlet>
  </main>

  <app-admin-action-menu></app-admin-action-menu>
</div>
